document.addEventListener("DOMContentLoaded",function() {
	const body             = document.body;
	const modeToggle    = document.documentElement.querySelector(".site-notification-banner__close");
	let currentMode = localStorage.getItem('notification');

	function setMode(mode) {
		if(mode === 'hide') {
			document.documentElement.classList.remove("site-notification--show");
			localStorage.setItem('notification', 'hide');
		}
	}

	// Blanket check on page load and add class to show notification if empty
	if(currentMode === 'hide') {
	} else {
		document.documentElement.classList.add("site-notification--show");
	}

	// Assign on toggle
	if (modeToggle) {
		modeToggle.addEventListener("click", function () {
			let currentMode = localStorage.getItem('notification');
			setMode('hide');
		})
	}

	if (!document.querySelector('.site-notification-banner')) {
		setMode('hide');
	}

});